var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":['event_group_name', 'event_group_short_name', 'wo_partner_name', 'ShopName'],"box":"","value":_vm.value,"label":_vm.label[_vm.$i18n.locale]},on:{"change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }